
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 5.5a.5.5 0 01-.5.5h-3a.5.5 0 010-1h3a.5.5 0 01.5.5zM20.5 8h-3a.5.5 0 000 1h3a.5.5 0 000-1zm0 3h-3a.5.5 0 000 1h3a.5.5 0 000-1zm0 3h-3a.5.5 0 000 1h3a.5.5 0 000-1zM15 10a5.982 5.982 0 01-1.75 4.231c-.003.003-.004.008-.008.011-.004.003-.008.004-.011.008A5.98 5.98 0 019 16c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6zM9.5 5.051v4.535c0 .131.054.26.146.354l3.207 3.207c.705-.862 1.146-1.948 1.146-3.146 0-2.586-1.98-4.694-4.5-4.949l.001-.001zM9 15c1.198 0 2.284-.441 3.146-1.146l-3.207-3.207A1.49 1.49 0 018.5 9.586V5.051C5.98 5.306 4 7.415 4 10c0 2.757 2.243 5 5 5zm15-9.5v9c0 2.481-2.019 4.5-4.5 4.5h-7v3h5a.5.5 0 010 1h-11a.5.5 0 010-1h5v-3h-7A4.505 4.505 0 010 14.5v-9C0 3.019 2.019 1 4.5 1h15C21.981 1 24 3.019 24 5.5zm-1 0C23 3.57 21.43 2 19.5 2h-15C2.57 2 1 3.57 1 5.5v9C1 16.43 2.57 18 4.5 18h15c1.93 0 3.5-1.57 3.5-3.5v-9z","fill":"#000C1F"}})])
          )
        }
      }
    